import * as React from 'react';
import Box from '@mui/material/Box';
import { getData } from '../redux/thunks/itemsApi';
import { t } from 'i18next';
import { baseUrl, Endpoints } from '../api';
import SellStyle from '../page/sell/Style';
import MultipleSelectCheckmarks from './atoms/MultiSelect';
import { useEffect, useState } from 'react';
import i18n from '../services/localization/i18n';
import { useDispatch } from 'react-redux';
import { ParamsInRedux, setCityId, setCountryId, setRegionId } from '../redux/slices/params';
import { useAppSelector } from '../redux/hooks';

const SelectLocation: React.FC = () => {
    const paramState = useAppSelector(ParamsInRedux);
    const disptach = useDispatch();
    const [regions, setRegions] = useState<any>([]);
    const [cities, setCities] = useState<any>([]);
    const [shouldClear, setShouldClear] = useState({
        region: false,
        city: false
    });
    const [countries, setCountries] = useState<any>([]);
    const [errors, setErrors] = useState({
        price: false,
        country: false,
        region: false,
        city: false
    });

    const nameWidthLang = `name_${i18n.language}`;

    const addIdToEach = (arr: any[], prop: any) => {
        if (!arr) return [];
        return arr.map((item: any) => ({ ...item, id: item[prop] }));
    };

    const getRegions = async (countryId: number) => {
        setCities([]);
        const normalizedCountryId = countryId <= 0 ? 0 : countryId;
        disptach(setCountryId(normalizedCountryId));
        disptach(setRegionId(0));
        disptach(setCityId(0));
        setShouldClear((prev: any) => ({ ...prev, region: true, city: true }));
        if (normalizedCountryId === 0) {
            setRegions([]);
            setShouldClear((prev: any) => ({ ...prev, region: false, city: false }));
            return;
        }
        const response = await getData(baseUrl + Endpoints.regions + `${countryId}`);
        if (response) {
            const regionsIdAdded = addIdToEach(response, 'regionId');
            setRegions(regionsIdAdded);
            setErrors((prev: any) => ({ ...prev, country: false }));
            setShouldClear((prev: any) => ({ ...prev, region: false }));
        }
    };

    const getCities = async (regionId: number) => {
        setShouldClear((prev: any) => ({ ...prev, city: true }));
        const normalizedRegionId = regionId <= 0 ? 0 : regionId;
        disptach(setRegionId(normalizedRegionId));
        disptach(setCityId(0));
        if (normalizedRegionId === 0) {
            setCities([]);
            setShouldClear((prev: any) => ({ ...prev, city: false }));
            return;
        }
        const response = await getData(baseUrl + Endpoints.cities + `${regionId}`);
        if (response) {
            const citiesIdAdded = addIdToEach(response, 'cityId');
            setCities(citiesIdAdded);
            setErrors((prev: any) => ({ ...prev, region: false }));
            setShouldClear((prev: any) => ({ ...prev, city: false }));
        }
    };
    const handleSetCity = (id: number) => {
        disptach(setCityId(id <= 0 ? 0 : id));
    };
    useEffect(() => {
        const getContries = async () => {
            const response = await getData(baseUrl + Endpoints.countries);
            const countriesIdAdded = addIdToEach(response, 'countryId');
            setCountries(countriesIdAdded);
        };
        getContries();
    }, []);
    return (
        <Box>
            {countries.length !== 0 && (
                <Box sx={SellStyle.multiBoxesContainer}>
                    <MultipleSelectCheckmarks
                        multiple={false}
                        options={countries}
                        onChange={(e: any) => {
                            setErrors((prev) => ({ ...prev, country: false }));
                        }}
                        displayValue={nameWidthLang}
                        selectId={getRegions}
                        hasError={errors.country}
                        errorMessage={t('web.sell-country-error_message')}
                        defaultValue={t('web.location-all-countries')}
                        isNoAutoChosen={true}
                    />
                    <MultipleSelectCheckmarks
                        defaultValue={t('web.location-all-regions')}
                        multiple={false}
                        options={regions}
                        onChange={() => {}}
                        displayValue={nameWidthLang}
                        selectId={getCities}
                        hasError={errors.region}
                        errorMessage={t('web.sell-region-error_message')}
                        shouldClear={shouldClear.region}
                        isNoAutoChosen={true}
                    />
                    <MultipleSelectCheckmarks
                        isNoAutoChosen={true}
                        defaultValue={t('web.location-all-cities')}
                        multiple={false}
                        options={cities}
                        onChange={(e: any) => {
                            setErrors((prev) => ({ ...prev, city: false }));
                        }}
                        displayValue={nameWidthLang}
                        selectId={handleSetCity}
                        hasError={errors.city}
                        errorMessage={t('web.sell-city-error_message')}
                        shouldClear={shouldClear.city}
                    />
                </Box>
            )}
        </Box>
    );
};

export default SelectLocation;
